import { Pipe, PipeTransform } from '@angular/core';

/**
 * Local replacement for the abandoned `ng2-truncate` package.
 * Usage: {{ value | truncate:limit:trail }} (defaults: limit 40, trail '...').
 */
@Pipe({
  name: 'truncate',
  standalone: false,
})
export class TruncatePipe implements PipeTransform {
  transform(value: string | null | undefined, limit = 40, trail = '...'): string {
    if (value == null) {
      return '';
    }
    const text = String(value);
    return text.length > limit ? text.substring(0, limit) + trail : text;
  }
}
